(() => {
  const SIZE_CHART_ALTS = [
    { test: /TOP_HALF_CHART/i, alt: 'Top half size chart with chest, sleeve, and torso measurements in inches' },
    { test: /BOTTOM_HALF_CHART/i, alt: 'Bottom half size chart with waist, hip, and inseam measurements in inches' },
    { test: /sizing_chart_chene/i, alt: 'Chêne Gear clothing size chart with measurements in inches' },
    { test: /how_to_measure/i, alt: 'Diagram showing how to measure chest, waist, hips, and inseam' }
  ];

  const setIfDifferent = (el, name, value) => {
    if (el.getAttribute(name) !== value) {
      el.setAttribute(name, value);
    }
  };

  const applyFixes = () => {
    document.querySelectorAll('#bmi-image, #boldmetrics-ssc-default img, .boldmetrics-ssc-button img').forEach((img) => {
      setIfDifferent(img, 'alt', '');
      setIfDifferent(img, 'aria-hidden', 'true');
      if (img.hasAttribute('role')) img.removeAttribute('role');
    });

    document.querySelectorAll('#boldmetrics-ssc-default, .boldmetrics-ssc-button').forEach((el) => {
      setIfDifferent(el, 'role', 'button');
      setIfDifferent(el, 'tabindex', '0');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Find my size');
      }
      if (el.dataset.a11yKeybound === 'true') return;
      el.dataset.a11yKeybound = 'true';
      el.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          el.click();
        }
      });
    });

    document.querySelectorAll('x-modal img, .modal img, .prose img').forEach((img) => {
      const src = img.getAttribute('src') || '';
      const match = SIZE_CHART_ALTS.find((item) => item.test.test(src));
      if (!match) return;
      setIfDifferent(img, 'alt', match.alt);
      if (img.hasAttribute('role')) img.removeAttribute('role');
      if (img.hasAttribute('data-ac-alt-type')) img.removeAttribute('data-ac-alt-type');
    });

    document.querySelectorAll('.yotpo-search-filter__icon-button').forEach((button) => {
      setIfDifferent(button, 'aria-label', 'Search reviews');
      if (button.hasAttribute('aria-labelledby')) {
        button.removeAttribute('aria-labelledby');
      }
    });

    document.querySelectorAll('[class*="yotpo"] input[type="text"], [class*="yotpo"] input[type="search"]').forEach((input) => {
      const hasLabel = Boolean(input.labels && input.labels.length) || Boolean(input.getAttribute('aria-label')) || Boolean(input.getAttribute('aria-labelledby'));
      if (!hasLabel) {
        input.setAttribute('aria-label', 'Search reviews');
      }
    });

    document.querySelectorAll('.yotpo-review-title').forEach((heading) => {
      const text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      const imgAlt = Array.from(heading.querySelectorAll('img')).some((img) => (img.getAttribute('alt') || '').trim());
      if (text || imgAlt) {
        if (heading.getAttribute('role') === 'none' || heading.getAttribute('role') === 'presentation') {
          heading.removeAttribute('role');
        }
        return;
      }
      heading.setAttribute('role', 'none');
    });

    document.querySelectorAll('#yotpo-reviews-section-data, [id*="yotpo"][style*="overflow"], [class*="yotpo"] div').forEach((el) => {
      if (el.tabIndex >= 0) return;
      if (el.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')) return;
      const style = window.getComputedStyle(el);
      const canY = (style.overflowY === 'auto' || style.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 2;
      const canX = (style.overflowX === 'auto' || style.overflowX === 'scroll') && el.scrollWidth > el.clientWidth + 2;
      if (canY || canX) {
        el.tabIndex = 0;
        if (!el.getAttribute('role')) el.setAttribute('role', 'region');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Customer reviews');
      }
    });

    document.querySelectorAll('#yotpo-reviews-section-data ul, [id*="yotpo"] ul, [class*="yotpo"] ul').forEach((list) => {
      if (list.children.length === 0 && !(list.textContent || '').trim()) {
        list.setAttribute('hidden', '');
        list.setAttribute('role', 'presentation');
      }
    });

    document.querySelectorAll('ul:empty, ol:empty').forEach((list) => {
      list.setAttribute('hidden', '');
      list.setAttribute('role', 'presentation');
    });

    document.querySelectorAll('.prose table, .rte table, article table, .shopify-policy__body table').forEach((table) => {
      if (table.dataset.a11yTable === '1') return;
      table.dataset.a11yTable = '1';
      const emptyHeaders = table.querySelectorAll('th');
      emptyHeaders.forEach((th) => {
        if (!(th.textContent || '').trim() && !th.querySelector('img[alt]:not([alt=""])')) {
          th.setAttribute('role', 'presentation');
        }
      });
      if (table.querySelector('th:not([role="presentation"])')) return;
      const firstRow = table.querySelector('tr');
      const cells = firstRow ? Array.from(firstRow.children) : [];
      const looksLikeHeader = cells.length > 1 && cells.every((cell) => (cell.textContent || '').trim().length < 48);
      if (looksLikeHeader) {
        cells.forEach((cell) => {
          if (cell.tagName !== 'TD') return;
          const th = document.createElement('th');
          th.scope = 'col';
          th.innerHTML = cell.innerHTML;
          cell.replaceWith(th);
        });
      } else if (!table.querySelector('th')) {
        table.setAttribute('role', 'presentation');
      }
    });

    document.querySelectorAll('a.cs-card[aria-label]').forEach((el) => {
      el.removeAttribute('aria-label');
    });

    document.querySelectorAll('a[href]').forEach((link) => {
      const text = (link.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/^(Read more|Buy Now|Reserve Now|Film Tour|Get The Recipe:?)$/i.test(text)) return;
      const context = (
        link.closest('.blog-post-card, .media-grid__item, .content-over-media, article, section')
          ?.querySelector('h1, h2, h3, h4, h5, h6, p')
          ?.textContent || ''
      ).replace(/\s+/g, ' ').trim();
      if (context && context !== text) {
        setIfDifferent(link, 'aria-label', `${text}: ${context}`);
      }
    });

    document.querySelectorAll('video[aria-label], video[aria-labelledby], video[aria-braillelabel]').forEach((video) => {
      const label = (video.getAttribute('aria-label') || '').trim();
      video.removeAttribute('aria-label');
      video.removeAttribute('aria-labelledby');
      video.removeAttribute('aria-braillelabel');
      if (!label) return;
      const host = video.closest('video-media, .product-gallery__media, figure') || video.parentElement;
      if (!host || host === video) return;
      if (host.getAttribute('aria-label') || host.getAttribute('aria-labelledby')) return;
      if (!host.getAttribute('role')) host.setAttribute('role', 'group');
      host.setAttribute('aria-label', label);
    });

    document.querySelectorAll('x-tabs').forEach((tabs) => {
      tabs.shadowRoot?.querySelectorAll('slot[role="tablist"]').forEach((slot) => slot.removeAttribute('role'));
      const looseTabs = Array.from(tabs.querySelectorAll(':scope > button[role="tab"]'));
      if (!looseTabs.length) return;
      let list = tabs.querySelector(':scope > [role="tablist"]');
      if (!list) {
        list = document.createElement('div');
        list.setAttribute('role', 'tablist');
        list.setAttribute('slot', 'title');
        list.setAttribute('aria-label', tabs.classList.contains('content-tabs') ? 'Product information' : 'Tabs');
        tabs.insertBefore(list, looseTabs[0]);
      }
      looseTabs.forEach((button) => {
        button.removeAttribute('slot');
        list.appendChild(button);
      });
    });

    document.querySelectorAll('iframe[data-testid="shop-cart-sync-iframe"], iframe[title="Shop Pay cart sync"]').forEach((iframe) => {
      const src = iframe.getAttribute('src');
      if (src === null || src === '') {
        iframe.setAttribute('src', 'about:blank');
      }
      if (!iframe.getAttribute('title')) {
        iframe.setAttribute('title', 'Shop Pay cart sync');
      }
    });

    document.querySelectorAll('.product-gallery__media').forEach((media) => {
      media.tabIndex = media.hidden ? -1 : 0;
      if (media.dataset.a11yKeybound === 'true') return;
      media.dataset.a11yKeybound = 'true';
      media.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        const img = media.querySelector('img');
        if (img) img.click();
      });
    });

    bindHeaderMenus();
    makeCartPricesFocusable();
    exposeMarketingDialogs();
    document.querySelectorAll('quick-buy-modal').forEach(bindQuickBuyFocus);
    syncVslyOverlay();
  };

  const isVariantOptionInput = (el) => el instanceof HTMLInputElement && el.matches('input[data-option-position]');
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    if (!isVariantOptionInput(event.target)) return;
    event.preventDefault();
    event.stopPropagation();
    if (!event.target.checked) {
      event.target.checked = true;
      event.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-share-url]');
    if (!trigger) return;
    const shareUrl = trigger.getAttribute('data-share-url');
    if (!shareUrl) return;
    event.preventDefault();
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
  });

  const MENU_SELECTOR = 'details.header__menu-disclosure, details[is="mega-menu-disclosure"], details[is="dropdown-menu-disclosure"]';

  const closeHeaderMenu = (menu) => {
    if (!menu) return;
    menu.open = false;
    menu.removeAttribute('open');
    menu.setAttribute('aria-expanded', 'false');
    menu.dataset.a11yIgnoreHover = 'true';
    menu.querySelectorAll(':scope > .mega-menu, :scope > .header__dropdown-menu').forEach((panel) => {
      panel.style.removeProperty('display');
    });
  };

  const MENU_CLOSE_LABEL = 'Close menu';
  const MENU_CLOSE_ICON = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg>';

  const normalizeMenuCloseButton = (button) => {
    if (!button) return;
    button.type = 'button';
    button.classList.remove('sr-only');
    button.classList.add('a11y-menu-close');
    button.setAttribute('tabindex', '0');
    const label = (button.getAttribute('aria-label') || button.textContent || MENU_CLOSE_LABEL).replace(/\s+/g, ' ').trim() || MENU_CLOSE_LABEL;
    button.setAttribute('aria-label', label);
    if (!button.querySelector('svg')) {
      button.innerHTML = `<span class="sr-only">${label}</span>${MENU_CLOSE_ICON}`;
    }
  };

  const ensureMenuCloseButton = (menu) => {
    const panel = menu.querySelector(':scope > .mega-menu, :scope > .header__dropdown-menu');
    if (!panel) return;

    let button = panel.querySelector('[data-a11y-menu-close]');
    if (!button) {
      button = document.createElement('button');
      button.setAttribute('data-a11y-menu-close', '');
    }

    normalizeMenuCloseButton(button);

    if (panel.tagName === 'UL') {
      let item = button.closest('li');
      if (!item || item.parentElement !== panel) {
        item = document.createElement('li');
        item.appendChild(button);
      }
      if (panel.lastElementChild !== item) panel.appendChild(item);
    } else if (panel.lastElementChild !== button) {
      panel.appendChild(button);
    }
  };

  const restoreMenuTrigger = (menu) => {
    const summary = menu?.querySelector(':scope > summary');
    summary?.focus({ preventScroll: true });
  };

  const bindHeaderMenus = () => {
    document.querySelectorAll(MENU_SELECTOR).forEach((menu) => {
      ensureMenuCloseButton(menu);
      if (menu.dataset.a11yMenuBound === 'true') return;
      menu.dataset.a11yMenuBound = 'true';

      let hoverTimer;

      const triggerMode = () => {
        if (!window.matchMedia('screen and (pointer: fine)').matches) return 'click';
        return menu.getAttribute('trigger') || 'click';
      };

      menu.addEventListener('mouseover', () => {
        if (triggerMode() !== 'hover' || menu.dataset.a11yIgnoreHover === 'true') return;
        window.clearTimeout(hoverTimer);
        menu.open = true;
        menu.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseout', () => {
        if (triggerMode() !== 'hover') return;
        hoverTimer = window.setTimeout(() => {
          if (menu.dataset.a11yIgnoreHover !== 'true') closeHeaderMenu(menu);
        }, 250);
      });

      menu.addEventListener('mouseleave', () => {
        delete menu.dataset.a11yIgnoreHover;
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' && event.code !== 'Escape') return;
        if (!(menu.open || menu.hasAttribute('open'))) return;
        window.clearTimeout(hoverTimer);
        closeHeaderMenu(menu);
        restoreMenuTrigger(menu);
        event.preventDefault();
        event.stopPropagation();
      });
    });
  };

  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('[data-a11y-menu-close]');
    if (!closeBtn) return;
    const menu = closeBtn.closest(MENU_SELECTOR);
    if (!menu) return;
    event.preventDefault();
    event.stopPropagation();
    closeHeaderMenu(menu);
    restoreMenuTrigger(menu);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    if (document.querySelector('cart-drawer[open], header-search[open], .header-search[open], x-modal[open], quick-buy-modal[open], #vsly-backdrop-container[role="dialog"], dialog[open], .pswp--open')) {
      return;
    }

    const openMenus = Array.from(document.querySelectorAll(MENU_SELECTOR)).filter((menu) => menu.open || menu.hasAttribute('open'));
    if (!openMenus.length) return;

    const focusedMenu = document.activeElement && document.activeElement.closest(MENU_SELECTOR);
    const menuToClose = focusedMenu && openMenus.includes(focusedMenu)
      ? focusedMenu
      : openMenus[openMenus.length - 1];
    openMenus.forEach(closeHeaderMenu);
    restoreMenuTrigger(menuToClose);
    event.preventDefault();
  }, true);

  const TABBABLE_SELECTOR = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([type="hidden"]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"]), [role="button"]:not([tabindex="-1"])';

  const isVisible = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    if (el.hasAttribute('hidden') || el.getAttribute('aria-hidden') === 'true') return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    return el.getClientRects().length > 0;
  };

  const isInside = (el, root) => {
    if (!el || !root) return false;
    let node = el;
    while (node) {
      if (node === root) return true;
      node = node.parentNode || node.host;
    }
    return false;
  };

  const getTabbable = (root) => {
    const nodes = [];
    const visit = (node) => {
      if (!node) return;
      if (node.nodeType === Node.ELEMENT_NODE && node.matches?.(TABBABLE_SELECTOR) && isVisible(node)) {
        nodes.push(node);
      }
      if (node.shadowRoot) visit(node.shadowRoot);
      node.childNodes.forEach((child) => visit(child));
    };
    visit(root);
    return [...new Set(nodes)];
  };

  const lockCartDrawer = (drawer, overlay) => {
    if (!drawer) return;
    drawer.focusTrap?.pause?.();
    if (overlay && drawer.contains(overlay)) {
      Array.from(drawer.children).forEach((child) => {
        if (child !== overlay && !child.contains(overlay)) child.setAttribute('inert', '');
      });
      return;
    }
    drawer.setAttribute('inert', '');
  };

  const releaseCartDrawer = (drawer) => {
    if (!drawer) return;
    drawer.removeAttribute('inert');
    Array.from(drawer.children).forEach((child) => child.removeAttribute('inert'));
    drawer.focusTrap?.unpause?.();
  };

  const bindQuickBuyFocus = (modal) => {
    if (modal.dataset.a11yFocusBound === 'true') return;
    modal.dataset.a11yFocusBound = 'true';

    let lockedDrawer = null;

    const activate = () => {
      lockedDrawer = document.querySelector('cart-drawer[open]');
      lockCartDrawer(lockedDrawer, modal);
      if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
      window.requestAnimationFrame(() => {
        const tabbable = getTabbable(modal);
        (tabbable[0] || modal).focus({ preventScroll: true });
      });
    };

    const deactivate = () => {
      const trigger = lockedDrawer && modal.id
        ? lockedDrawer.querySelector(`[aria-controls="${modal.id}"]`)
        : null;
      releaseCartDrawer(lockedDrawer);
      lockedDrawer = null;
      trigger?.focus({ preventScroll: true });
    };

    if (modal.hasAttribute('open')) activate();
    modal.addEventListener('dialog:after-show', activate);
    modal.addEventListener('dialog:after-hide', deactivate);
  };

  const getVslyDialog = () => {
    const dialog = document.getElementById('vsly-backdrop-container');
    if (!dialog) return null;
    if (dialog.getAttribute('role') !== 'dialog' && dialog.getAttribute('aria-modal') !== 'true') return null;
    const panel = dialog.querySelector('.vsly-atc-overlay-content, .vsly-atc-overlay-header') || dialog;
    if (!isVisible(dialog) && !isVisible(panel)) return null;
    return dialog;
  };

  const THEME_CHROME = 'cart-drawer, header-search, quick-buy-modal, x-modal, #vsly-backdrop-container, .header-sidebar, cart-note-dialog, details';

  const isThemeChrome = (el) => Boolean(el && (el.matches?.(THEME_CHROME) || el.closest?.(THEME_CHROME)));

  const findOverlayRoot = (el) => {
    const labeled = el.closest('[role="dialog"], [aria-modal="true"], newsletter-popup, privacy-banner');
    if (labeled && !isThemeChrome(labeled)) return labeled;
    let node = el;
    while (node && node !== document.body) {
      const style = window.getComputedStyle(node);
      if (style.position === 'fixed' && node.getClientRects().length > 0) {
        const rect = node.getBoundingClientRect();
        if (rect.width >= Math.min(320, window.innerWidth * 0.4) && rect.height >= 120) {
          return node;
        }
      }
      node = node.parentElement;
    }
    return el;
  };

  const isPopupOverlay = (root) => {
    if (!root) return false;
    if (root.matches?.('newsletter-popup[open], privacy-banner[open]')) return true;
    if (root.getAttribute('role') === 'dialog' || root.getAttribute('aria-modal') === 'true') return true;
    const style = window.getComputedStyle(root);
    if (style.position !== 'fixed' && style.position !== 'absolute') return false;
    const rect = root.getBoundingClientRect();
    return rect.width >= 280 && rect.height >= 160;
  };

  const getMarketingDialog = () => {
    const nodes = document.querySelectorAll(
      'newsletter-popup[open], privacy-banner[open], .klaviyo-form, [class*="klaviyo-form"], form.needsclick, [data-testid="FORM"], [role="dialog"][aria-modal="true"]'
    );
    for (const node of nodes) {
      if (isThemeChrome(node) || node.id === 'vsly-backdrop-container') continue;
      if (!isVisible(node)) continue;
      const root = findOverlayRoot(node);
      if (isThemeChrome(root) || root.id === 'vsly-backdrop-container') continue;
      if (!isPopupOverlay(root)) continue;
      if (!root.querySelector('input, button, [type="checkbox"], [role="checkbox"], [role="switch"]')) continue;
      return root;
    }
    return null;
  };

  const markDialogCopy = (el) => {
    if (!el) return;
    if (!el.id) el.id = `a11y-dialog-copy-${Math.random().toString(36).slice(2, 8)}`;
    el.setAttribute('tabindex', '0');
    el.setAttribute('data-a11y-dialog-copy', '');
  };

  const exposeDialogCopy = (root) => {
    if (!root) return;
    const blocks = Array.from(root.querySelectorAll('h1, h2, h3, h4, h5, h6, p, legend, [data-testid="form-component-RICH_TEXT"]')).filter((el) => {
      if (el.closest('label, button, a, [role="checkbox"]')) return false;
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      return text.length > 8;
    }).slice(0, 3);

    blocks.forEach(markDialogCopy);
    if (blocks[0]) root.setAttribute('aria-labelledby', blocks[0].id);
    if (blocks[1]) root.setAttribute('aria-describedby', blocks[1].id);
    if (!root.getAttribute('role')) root.setAttribute('role', 'dialog');
    if (!root.getAttribute('aria-modal')) root.setAttribute('aria-modal', 'true');

    const key = blocks.map((el) => (el.textContent || '').replace(/\s+/g, ' ').trim()).join('|').slice(0, 240);
    if (key && root.dataset.a11yCopyKey !== key) {
      root.dataset.a11yCopyKey = key;
      window.requestAnimationFrame(() => {
        blocks[0]?.focus({ preventScroll: true });
      });
    }
  };

  const exposeMarketingDialogs = () => {
    const dialog = getMarketingDialog();
    if (dialog) exposeDialogCopy(dialog);
  };

  const getDialogTabbable = (root) => {
    const nodes = getTabbable(root);
    const copy = nodes.filter((node) => node.hasAttribute('data-a11y-dialog-copy'));
    const rest = nodes.filter((node) => !node.hasAttribute('data-a11y-dialog-copy'));
    return copy.length ? [...copy, ...rest] : nodes;
  };

  const makeCartPricesFocusable = () => {
    document.querySelectorAll('cart-drawer price-list, .line-item price-list').forEach((el) => {
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'group');
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) el.setAttribute('aria-label', text);
    });

    document.querySelectorAll('#vsly-backdrop-container .vsly-atc-overlay-header-price, #vsly-backdrop-container .vsly-atc-overlay-header-prices').forEach((el) => {
      el.setAttribute('tabindex', '0');
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (text) el.setAttribute('aria-label', text);
    });
  };

  const getVslySizeButtons = (dialog) => {
    const content = dialog.querySelector('.vsly-atc-overlay-content') || dialog;
    return Array.from(content.querySelectorAll('button')).filter((button) => {
      if (!isVisible(button) || button.disabled) return false;
      if (button.classList.contains('vsly-atc-overlay-btn')) return false;
      if (button.closest('.vsly-atc-overlay-header, .vsly-atc-overlay-footer')) return false;
      const label = (button.getAttribute('aria-label') || button.textContent || '').trim().toLowerCase();
      return !/add to cart|close/.test(label);
    });
  };

  const getOpenModal = () => getVslyDialog() || document.querySelector('quick-buy-modal[open]') || getMarketingDialog();

  let vslyLockedDrawer = null;

  const syncVslyOverlay = () => {
    const dialog = getVslyDialog();
    if (dialog) {
      const drawer = document.querySelector('cart-drawer[open]');
      if (drawer) {
        lockCartDrawer(drawer, dialog);
        vslyLockedDrawer = drawer;
      }
      if (dialog.dataset.a11yFocusBound !== 'true') {
        dialog.dataset.a11yFocusBound = 'true';
        if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
        window.requestAnimationFrame(() => {
          const tabbable = getTabbable(dialog);
          (tabbable[0] || dialog).focus({ preventScroll: true });
        });
      }
      return;
    }
    if (vslyLockedDrawer) {
      releaseCartDrawer(vslyLockedDrawer);
      vslyLockedDrawer = null;
    }
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' && event.code !== 'Escape') return;
    const dialog = getVslyDialog();
    if (!dialog) return;
    const closeBtn = dialog.querySelector('[aria-label="Close"], .vsly-svg-btn[role="button"]');
    event.preventDefault();
    event.stopPropagation();
    if (typeof closeBtn?.click === 'function') closeBtn.click();
  }, true);

  document.addEventListener('keydown', (event) => {
    const dialog = getVslyDialog();
    if (!dialog) return;
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
    const sizes = getVslySizeButtons(dialog);
    if (!sizes.length) return;
    const current = sizes.find((button) => button === event.target || button.contains(event.target));
    if (!current) return;

    event.preventDefault();
    event.stopPropagation();
    let index = sizes.indexOf(current);
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % sizes.length;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index - 1 + sizes.length) % sizes.length;
    else if (event.key === 'Home') index = 0;
    else index = sizes.length - 1;

    const next = sizes[index];
    next.focus({ preventScroll: true });
    if (typeof next.click === 'function' && next !== current) next.click();
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const modal = getOpenModal();
    if (!modal) return;

    const marketing = getMarketingDialog();
    const tabbable = modal === marketing ? getDialogTabbable(modal) : getTabbable(modal);
    if (!tabbable.length) {
      event.preventDefault();
      modal.focus({ preventScroll: true });
      return;
    }

    const active = document.activeElement;
    const shadowActive = modal.shadowRoot && modal.shadowRoot.activeElement;
    const current = (shadowActive && isInside(shadowActive, modal) ? shadowActive : null)
      || (isInside(active, modal) ? active : null);
    const first = tabbable[0];
    const last = tabbable[tabbable.length - 1];
    const fullyManage = Boolean(marketing && modal === marketing);

    if (!current) {
      event.preventDefault();
      if (fullyManage) event.stopImmediatePropagation();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
      return;
    }

    if (fullyManage) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const index = Math.max(0, tabbable.indexOf(current));
      const nextIndex = event.shiftKey
        ? (index - 1 + tabbable.length) % tabbable.length
        : (index + 1) % tabbable.length;
      tabbable[nextIndex].focus({ preventScroll: true });
      return;
    }

    if (!event.shiftKey && current === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    } else if (event.shiftKey && current === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    }
  }, true);

  document.addEventListener('focusin', (event) => {
    const modal = getOpenModal();
    if (!modal) return;
    if (isInside(event.target, modal)) return;
    const marketing = getMarketingDialog();
    const tabbable = modal === marketing ? getDialogTabbable(modal) : getTabbable(modal);
    (tabbable[0] || modal).focus({ preventScroll: true });
  }, true);

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyFixes();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFixes, { once: true });
  } else {
    applyFixes();
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const poll = window.setInterval(() => {
    applyFixes();
    attempts += 1;
    if (attempts >= 20) window.clearInterval(poll);
  }, 500);
})();
